module.exports = __webpack_public_path__ + "ddc348f204283c4f4090a3ed03853054.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/SemiboldItalic/OpenSans-SemiboldItalic.svg?v=1.1.0
// module id = 1001
// module chunks = 0